import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import OrderForm from "@/components/OrderForm";
import PriceEstimator from "@/components/PriceEstimator";
import { useAuth } from "@/context/AuthContext";
import { useNavigate } from "react-router-dom";

export default function PharmacyStaffNew() {
  const { user } = useAuth();
  const navigate = useNavigate();
  const [pharmacies, setPharmacies] = useState([]);
  // When the staff clicks "Use this address" on the estimator, we hand the
  // address + deliver_type over to the OrderForm via these initial-* props.
  const [seed, setSeed] = useState({ address: "", deliver_type: "same_day" });

  useEffect(() => {
    api.get("/pharmacies").then((r) => setPharmacies(r.data));
  }, []);

  const isPharmacyStaff = user?.role === "pharmacy_staff";

  return (
    <div className={`p-6 lg:p-10 ${isPharmacyStaff ? "max-w-6xl" : "max-w-2xl"} mx-auto`} data-testid="staff-new-order-page">
      <header className="mb-6">
        <h1 className="text-3xl font-display font-bold tracking-tight">New delivery order</h1>
        <p className="text-muted-foreground text-sm mt-1">Fill in customer details, items and delivery address.</p>
      </header>

      <div className={isPharmacyStaff ? "grid md:grid-cols-[320px,1fr] gap-6 items-start" : ""}>
        {isPharmacyStaff && (
          <aside className="md:sticky md:top-6">
            <PriceEstimator
              pharmacyId={user?.pharmacy_id}
              defaultDeliverType={seed.deliver_type}
              onApply={({ address, deliver_type }) => setSeed({ address, deliver_type })}
            />
          </aside>
        )}
        <div>
          <OrderForm
            pharmacies={pharmacies}
            defaultPharmacyId={user?.pharmacy_id}
            allowPharmacySelect={user?.role !== "pharmacy_staff"}
            initialAddress={seed.address}
            initialDeliverType={seed.deliver_type}
            onCreated={(data) => navigate("/staff", { state: { newOrder: data } })}
            onCancel={() => navigate("/staff")}
          />
        </div>
      </div>
    </div>
  );
}
